import styled, { css } from 'styled-components/macro'
import { mq } from 'styles/mq'

export const containerStyle = css`
  padding: 0 var(--container-spacing);
  width: 100%;
  max-width: calc(var(--container-width) + 2 * var(--container-spacing));
  margin: 0 auto;
`

export const Container = styled.div<{ $fluid?: boolean }>`
  ${containerStyle}

  ${props =>
    props.$fluid &&
    css`
      max-width: unset;
    `}
`

export const TextContainer = styled.div<{ position?: string }>`
  ${containerStyle}
  --container-width: calc(10 * var(--grid-size) + 9 * var(--gap-size));

  max-width: var(--container-width);
  hyphens: auto;
  text-align: justify;
  &.komi-mythology-margin-bottom {
    ${mq.smallOnly} {
      margin-bottom: 3rem;
    }
  }

  ${props =>
    !!props.position &&
    css`
      position: ${props.position};
    `}

  ${mq.medium} {
    --container-width: calc(8 * var(--grid-size) + 9 * var(--gap-size));
    --container-spacing: var(--gap-size);

    padding: 0 var(--container-spacing);
  }
`

export const ArticleContent = styled.div`
  font-size: 1.5rem;

  ${mq.medium} {
    font-size: 2rem;
  }

  * {
    line-height: 1.6;
  }

  h2 {
    font-size: 2.4rem;
    line-height: 1.25;
    font-weight: 800;

    ${mq.medium} {
      font-size: 3.5rem;
    }

    ${mq.large} {
      font-size: 4.1rem;
    }
  }

  h3 {
    ${mq.medium} {
      font-size: 2.4rem;
    }
  }

  a {
    color: inherit;
    padding: 0.1em 0;
    transition: 0.3s background-color;
    background-color: var(--links-color);

    &:hover {
      background-color: var(--theme-color);
    }
  }
`
